import { Plural, Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';
import { PickupPointInfo } from '@/routes/Brand/Requests/Request/components/shared/PickupPointInfo/PickupPointInfo';

import { StepMessage } from '../../shared/StepMessage';

const Analysis = ({ request }: { request: RequestWithRelations }) => {
  const activeArticlesInAnalysisOrTransitWorkshopToWorkshop = request.articles.filter(
    (article) =>
      !article.cancelledAt &&
      (article.step?.step === 'analysis' ||
        (article.step?.step === 'transit' &&
          article.step.config.originType === 'workshop' &&
          article.step.config.destinationType === 'workshop'))
  );

  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />

        <StepMessage
          message={
            <Trans id="client.request.analysis.text">
              Your{' '}
              <Plural
                value={activeArticlesInAnalysisOrTransitWorkshopToWorkshop.length}
                one="item is"
                other="items are"
              />{' '}
              being analyzed by the workshop to see if the required actions correspond to{' '}
              <Plural
                value={activeArticlesInAnalysisOrTransitWorkshopToWorkshop.length}
                one="its"
                other="their"
              />{' '}
              needs.
            </Trans>
          }
        />

        <Stack gap="1rem">
          <PickupPointInfo request={request} />
          <ClientArticlesList request={request} showPrice showArticleComment />
        </Stack>
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Analysis;
